<template>
  <div class="px-5">
    <template v-for="(currentDetail, index, i) in modelProxy">

      <div :class="{'mt-5': +i !== 0}"
      :ref="`knit_request_${currentDetail.id}`"
      :id="`knit_request_${currentDetail.id}`"
      >
      <div class="d-flex navy-blue-border-bottom-1px px-2 py-2">
        <span class="h6 text-sm mr-2">{{$t('general.created_at')}}:</span><span class="text-sm">{{currentDetail.created_at?moment(currentDetail.created_at).format('DD.MM.YYYY hh:mm:ss'):moment().format('DD.MM.YYYY hh:mm:ss')}}</span>
        
        <span class="mx-1 h25"> / </span>
        <span class="h6 text-sm mr-2">
          {{$t('general.updated_date')}}:</span><span class="text-sm"> {{currentDetail.updated_at?moment(currentDetail.updated_at).format('DD.MM.YYYY hh:mm:ss'):moment().format('DD.MM.YYYY hh:mm:ss')}}</span>
        
     </div>

      <div style="overflow-x: auto !important;">
        <div class="d-flex">
          <div class="py-2 text-center col-6 top-1-items">
            {{ $t('order.supplier_company') }}
          </div>
          <div class="py-2 text-center col-6 top-1-items">
            {{ $t('order.dispatch_location') }}
          </div>
          <div class="py-2 text-center col-6 top-1-items">
            {{ $t('order.fabric_type') }}
          </div>
          <div class="py-2 text-center col-6 top-1-items">
            {{ $t('order.knit_type') }}
          </div>
          <div class="py-2 text-center col-6 top-1-items">
            {{ $t('order.weight_with_unit') }}
          </div>

          <div class="py-2 text-center col-6 top-1-items">
            {{ $t('order.flow_date') }}
          </div>
          <div class="py-2 text-center col-6 top-1-items" style="border-right: none !important;">
            {{ $t('order.end_date') }}
          </div>
        </div>
        <div class="d-flex">
          <div class="py-2 text-center col-6 top-1-items d-flex mx-0 px-0" style="justify-content:center !important;">
            <custom-multi-select
                :has-bottom-margin="false"
                :item-per-row="1"
                :max="1"
                :disabled="currentDetail.lockable_company &&  isUserGranted('Order', ['updateInstructionSupplierCompany'],false,true)"
                :model.sync="currentDetail.supplier_company_id"
                :name="`order_fabric_knit_type_supplier_company_${index}`"
                :not-list="true"
                :options="supplierCompanyOptions"
                :required="false"
                :title="null"
                size="sm"
            ></custom-multi-select>
          </div>
          <div class="py-2 text-center col-6 top-1-items d-flex mx-0 px-0" style="justify-content:center !important;">
            <custom-multi-select
                :has-bottom-margin="false"
                :is-right="true"
                :item-per-row="1"
                :model.sync="currentDetail.dispatch_location_ids"
                :name="`order_fabric_knit_type_dispatch_location_${index}`"
                :options="dispatchLocationOptions"
                :required="false"
                :title="null"
                :max="1"
                size="sm"
            ></custom-multi-select>
          </div>
          <div class="py-2 text-center col-6 top-1-items d-flex mx-0 px-0" style="justify-content:center !important;">
            <div class="p-2">
              <input v-model="currentDetail.fabric_type"
                     :class="{'is-invalid': !currentDetail.fabric_type}"
                     :name="`order_fabric_knit_type_fabric_type_${index}`"
                     :placeholder="$t('order.please_enter_fabric_type')"
                     class="form-control form-control-sm"
                     type="text">
            </div>
          </div>
          <div class="py-2 text-center col-6 top-1-items d-flex mx-0 px-0" style="justify-content:center !important;">
            <custom-multi-select
                :has-bottom-margin="false"
                :item-per-row="1"
                :max="1"
                :model.sync="currentDetail.fabric_knit_type_id"
                :name="`order_fabric_knit_fabric_knit_type_${index}`"
                :not-list="true"
                :options="fabricKnitTypeOptions"
                :required="false"
                :title="null"
                size="sm"
            ></custom-multi-select>
          </div>
          <div
          class="py-2 text-center col-6 top-1-items d-flex mx-0 px-0" style="justify-content:center !important;">
            <div>
              <input
                  v-model="currentDetail.weight"
                  :class="{'is-invalid': !currentDetail.weight}"
                  :name="`order_fabric_ready_made_weight_${index}`"
                  :placeholder="$t('order.please_enter_weight')"
                  :required="false"
                  class="form-control form-control-sm"
                  type="text"
              >
            </div>
          </div>
          <div
          class="py-2 text-center col-6 top-1-items d-flex mx-0 px-0" style="justify-content:center !important;">
            <div>
              <date-picker-input
                  :has-bottom-margin="false"
                  :input-classes="'w-85px'"
                  :model.sync="currentDetail.flow_date"
                  :name="`order_flow_date_${index}`"
                  :required="false"
                  :title="null"
              ></date-picker-input>
            </div>
          </div>
          <div class="py-2 text-center col-6 top-1-items d-flex mx-0 px-0" style="justify-content:center !important;">
            <date-picker-input
                :has-bottom-margin="false"
                :input-classes="'w-85px'"
                :model.sync="currentDetail.end_date"
                :name="`order_end_date_${index}`"
                :required="false"
                :title="null"
            ></date-picker-input>
          </div>
        </div>
      </div>
        

        <div style="overflow-x: auto !important;">
          <div class="d-flex">
          <div class="py-2 text-center col-6 top-1-items">
            {{ $t('order.color') }}
          </div>
          <div class="py-2 text-center col-6 top-1-items">
            {{ $t('order.fein_pus') }}
          </div>
          <div class="py-2 text-center col-6 top-1-items">
            {{ $t('order.color') }}
          </div>
          <div class="py-2 text-center col-6 top-1-items">
            {{ $t('order.quantity') }}
          </div>
          <div class="py-2 text-center col-6 top-1-items">
            {{ $t('order.unit') }}
          </div>
          <div class="py-2 text-center col-6 top-1-items">
            {{ $t('order.tolerance_quantity') }}(%)
          </div>
          <div class="py-2 text-center col-6 top-1-items">
            {{ $t('order.total_quantity') }}
          </div>
          <div class="py-2 text-center col-6 top-1-items">
            {{ $t('order.incoming_quantity') }}
          </div>
          <div class="py-2 text-center col-6 top-1-items" style="border-right: none !important;">
            {{ $t('order.remaining_quantity') }}
          </div>
        </div>
        <div class="d-flex ">
          <div class="py-2 text-center col-6 top-1-items">
            <div class="px-2">
              <custom-multi-select
                  :item-per-row="1"
                  :max="1"
                  :model.sync="currentDetail.order_size_and_color_id"
                  :not-list="true"
                  :options="orderSizeAndColorOptions"
                  :placeholder="$t('general.please_select_option')"
                  :required="false"
                  :title="null"
                  name="orderSizeAndColorOptions"
                  width="300px"
                  @onSelect="orderSizeAndColorSave($event, index)"
              ></custom-multi-select>
            </div>
          </div>
          <div class="py-2 text-center col-6 top-1-items">
            <div class="p-2">
              <input
                  v-model="currentDetail.fein_pus"
                  :class="{'is-invalid': !currentDetail.fein_pus}"
                  :name="`order_fabric_knit_type_fein_pus_${index}`"
                  :placeholder="$t('order.please_enter_fein_pus')"
                  :required="false"
                  :title="null"
                  class="form-control form-control-sm"
                  type="text"
              />
            </div>
          </div>
          <div class="py-2 text-center col-6 top-1-items">
            <div class="p-2">
              <input
                  v-model="currentDetail.color"
                  :class="{'is-invalid': !currentDetail.color}"
                  :name="`order_fabric_knit_type_color_${index}`"
                  :placeholder="$t('order.please_enter_color')"
                  :required="false"
                  :title="null"
                  class="form-control form-control-sm"
                  type="text"
              />
            </div>
          </div>
          <div class="py-2 text-center col-6 top-1-items">
            <div class="p-2">
              <input
                  v-model="currentDetail.amount"
                  :class="{'is-invalid': !currentDetail.amount}"
                  :name="`order_fabric_knit_type_amount_${index}`"
                  :placeholder="$t('order.please_enter_quantity')"
                  :required="false"
                  :title="null"
                  class="form-control form-control-sm"
                  min="0"
                  step="0.01"
                  type="number"
              />
            </div>
          </div>
          <div
              class="py-2 text-center col-6 top-1-items">
              <div class="p-2">
                <custom-multi-select
                    :has-bottom-margin="false"
                    :item-per-row="2"
                    :max="1"
                    :model.sync="currentDetail.amount_unit_id"
                    :name="`amount_unit_id_${index}`"
                    :not-list="true"
                    :options="amountUnitOptions"
                    :required="false"
                    :title="null"
                    size="sm"
                ></custom-multi-select>
            </div>
          </div>
          <div class="py-2 text-center col-6 top-1-items">
            <div class="px-2">
              <input
                  v-model="currentDetail.tolerance_amount"
                  :class="{'is-invalid': !+currentDetail.tolerance_amount || +currentDetail.tolerance_amount > 100 || +currentDetail.tolerance_amount < 0 }"
                  :disabled="true"
                  :name="`order_fabric_knit_type_amount_tolerance_quantity_${index}`"
                  :placeholder="$t('order.please_enter_tolerance_amount')"
                  :required="false"
                  :step="1"
                  :title="null"
                  class="form-control form-control-sm"
                  type="number"
              >
            </div>
          </div>
          <div class="py-2 text-center col-6 top-1-items">
            {{ totalAmount(index) | amountFormat}}
          </div>
          <div class="py-2 text-center col-6 top-1-items">{{ currentDetail.incoming_amount | amountFormat }}</div>
          <div class="py-2 text-center col-6 top-1-items" style="border-right: none !important;">{{ currentDetail.remaining_amount | amountFormat }}</div>
        </div>
        </div>
        

        <test-method-row
            :is-required="false"
            :product-processes.sync="currentDetail.product_processes"
            :selected-test-methods.sync="currentDetail.selectedProductProcesses"
            :test-method-options="productProcesses"
        ></test-method-row>

        <currency-table-row
            :currency-options="currencyOptions"
            :currency-options-raw="currencyOptionsRaw"
            :currency-rate-options="currencyRateOptions"
            :expiration-type-options="expirationTypeOptions"
            :model="currentDetail"
            :v-a-t-rate-options="VATRateOptions"
        ></currency-table-row>

        <div class="d-flex mt-5 txt-area">
          <div class="flex-1 px-2 py-3">
            <span class="text-md font-weight-bolder mx-2">{{$t('order.description')}}</span>
            <textarea-input
                :is-valid="!!currentDetail.description"
                :model.sync="currentDetail.description"
                :name="`order_fabric_yarn_fabric_description_${index}`"
                :required="false"
            ></textarea-input>
          </div>
        </div>
      </div>
      <span v-if="index > 0 && !currentDetail.id" class="cursor-pointer" @click="deleteNewDetail(index)" v-html="getIconByKey('icons.sample.delete_red',{
                        class: 'w-20px h-20px d-inline-block mr-3 '
                      })"></span>

      <span v-if="isValidToSubmit && index == modelProxy.length - 1"
            class="cursor-pointer"
            @click="addNewDetail"
            v-html="getIconByKey('icons.waybill.waybill_entry', {
            class: 'w-50px h50px d-line-block object-fill',
          })"
      ></span>

      <bottom-buttons
          :emails="[]"
          :is-editing.sync="currentDetail.is_editing"
          :is-valid-to-submit="isValidToSubmit(index)"
          :model="currentDetail"
          :order-id="orderId"
          :send-mail-url="sendMailUrl(index)"
          name="yarn-request"
          @addNewDetail="addNewDetail"
          @onCancelInstruction="onCancelInstruction($event, currentDetail.id, index)"
          @submit="submitOrderFabricKnit ($event, index)"
      ></bottom-buttons>
    </template>
  </div>
</template>

<script>
import TextInput from "@/assets/components/inputs/TextInput";
import NumberInput from "@/assets/components/inputs/NumberInput";
import TextareaInput from "@/assets/components/inputs/TextareaInput";
import CustomMultiSelect from "@/assets/components/inputs/CustomMultiSelect";
import DatePickerInput from "@/assets/components/inputs/DatePickerInput";
import _ from "lodash";
import CurrencyTableRow from "@/view/pages/order/layout/CurrencyTableRow";
import TestMethodRow from "@/view/pages/order/layout/TestMethodRow";
import BottomButtons from "@/view/pages/order/layout/BottomButtons";
import moment from "moment";
import {LARAVEL_DATE_TIME_FORMAT} from "@/core/config/constant";
import {CREATE_ITEM, DELETE_ITEM_BY_ID} from "@/core/services/store/REST.module";

export default {
  name: "OrderFabricKnitTypeTable",
  components: {
    BottomButtons,
    TestMethodRow,
    CurrencyTableRow, DatePickerInput, CustomMultiSelect, TextareaInput, NumberInput, TextInput
  },
  props: {
    model: {
      required: true
    },
    totalInstructions:{
      required:false,
    },
    maxPrice:{
      required: false,
    },
    maxPriceUnit:{
      required:false,
    },

    amountUnitOptions: {
      required: true
    },
    yarnModel: {
      required: true,
      type: Array,
    },
    defaultModel: {
      required: true
    },
    currentInstructionTypeId: {
      required: true,
    },
    orderId: {
      required: true,
      default: null,
    },
    order: {
      required: true,
      default: null
    },
    supplierCompanyOptions: {
      required: true,
    },
    fabricTypeOptions: {
      required: true,
    },
    fabricKnitTypeOptions: {
      required: true,
    },
    dispatchLocationOptions: {
      required: true,
    },
    currencyOptions: {
      required: true,
    },
    expirationTypeOptions: {
      required: false,
    },
    VATRateOptions: {
      required: true,
    },
    currencyRateOptions: {
      required: true,
    },
    didChangeProcessingType: {
      required: true,
      type: Boolean,
    },
    tolerances: {
      required: true,
    },
    currencyOptionsRaw: {
      required: true
    },
    productProcesses: {
      required: true,
    },
    orderFabricOptions: {
      required: true,
    },
    fabricProcessingType: {
      required: true,
    },
    orderFabricId: {
      required: true,
    },
    pressTypeId: {
      required: false,
    },
    pressTypeTolerances: {
      required: false
    },
    orderSizeAndColorOptions: {
      required: true,
    }
  },
  data() {
    return {
      is_submitting: false
    }
  },
  methods: {
    maxPriceCheck(index){
      console.log(index);
      let modelTotal = 0;
      let fabricCurrencyUnit=this.maxPriceUnit;
      let allCurrencyRate=this.currencyRateOptions;
      let orderFabric = _.find(this.order.order_fabrics,{'id':+this.orderFabricId});
      let modelItem = this.model[index];

      let modelExchanegeRate=1;
      let modelCurrencyUnit=null;
      if(modelItem.currency_unit){
        modelCurrencyUnit=modelItem.currency_unit.code;
      }else{
        modelCurrencyUnit=this.currencyOptions[modelItem.currency_unit_id];
      }
      
      let findCurrencyForFabric=_.find(allCurrencyRate,{"code":fabricCurrencyUnit});
      let findCurrencyForModel=_.find(allCurrencyRate,{"code":modelCurrencyUnit});

      if((modelCurrencyUnit=="TL"||modelCurrencyUnit=="TRY")&&(fabricCurrencyUnit=="TRY"||fabricCurrencyUnit=="TL")){
        modelExchanegeRate=findCurrencyForFabric.rate;
        modelTotal+=Number(modelItem.total_price)/modelExchanegeRate;
      }else if(fabricCurrencyUnit==modelCurrencyUnit){
        modelTotal+=Number(modelItem.total_price);
      }else{

        modelExchanegeRate=findCurrencyForModel.rate/orderFabric.exchange_rate;
        modelTotal+=Number(modelItem.total_price)*modelExchanegeRate;
      }
      let modelPlusTotalAllInstructions=this.totalInstructions;
      console.log(modelPlusTotalAllInstructions);
      if(modelPlusTotalAllInstructions>this.maxPrice){
        return false;
      }
      return true;
    },

    orderSizeAndColorSave(selectedValue, index) {
      let model = this.modelProxy[index];
      let value = Number(selectedValue);
      let yarnModels = this.yarnModel.filter(item => +item.order_size_and_color_id === +value);
      let amount = 0;
      yarnModels.forEach(yarnModel => {
        amount += Number(yarnModel.amount);
      })
      if (+model.fabric_supply_type_id === 1) {
        amount = amount + amount * this.tolerances.paint_coefficient / 100;
      } else if (+model.fabric_supply_type_id === 2) {
        amount = amount + amount * this.pressTypeTolerances[this.pressTypeId] / 100;
      }
      model.amount = amount ? amount.toFixed(2) : 0;
    },
    onCancelInstruction($event, itemId, index) {
      const self = this;
      this.$store.dispatch(DELETE_ITEM_BY_ID, {
        url: `api/order/${this.orderId}/knit-request/${itemId}`
      }).then(function (response) {
        if (response.status) {
          self.sweetAlertSuccess(self.$t('general.successfully_deleted'));
          self.modelProxy.splice(index, 1);
          if (!self.modelProxy.length) {
            self.modelProxy = [self.defaultModel];
          }
        } else {
          self.sweetAlertError(self.$t('general.internal_error'));
        }
      });
    },
    deleteNewDetail(index) {
      this.modelProxy.splice(index, 1);
    },
    addNewDetail() {
      let copy = _.cloneDeepWith(this.defaultModel);
      copy.is_submitted = false;
      copy.is_editing = false;
      copy.amount = 0;
      copy.id = null;
      this.modelProxy.push(copy);
    },
    fixedData(index) {
      let items = [];
      let self = this;
      let item = this.modelProxy[index];

      item.dispatch_locations = item.dispatch_location_ids.map(location => {
        return {
          id: location,
        }
      });

      item.order_fabric_id = self.orderFabricId;
      item.press_type_id = self.pressTypeId;
      item.flow_date = moment(item.flow_date).format(LARAVEL_DATE_TIME_FORMAT);
      item.end_date = moment(item.end_date).format(LARAVEL_DATE_TIME_FORMAT);

      items.push(item);

      return items;
    },
    submitOrderFabricKnit($event, index) {
      let maxControl = this.maxPriceCheck(index);
      if(maxControl==false){
        this.sweetAlertError(this.$t('order.instruction_max_error'));
        return false;
      }

      if (this.is_submitting) return false;
      this.is_submitting = true;
      this.sweetAlertLoading();
      this.updateOrCreate(index);
    },
    updateOrCreate(index) {
      const self = this;
      self.$store.dispatch(CREATE_ITEM, {
        url: `api/order/${self.orderId}/knit-request`,
        contents: {
          order_knit_requests: self.fixedData(index),
        }
      }).then(response => {
        if (response.status) {
          let detail = self.modelProxy[index];
          let responseData = response.data[0];
          detail.id = responseData.id
          detail.is_submitted = true;
          detail.is_editing = false;
          detail.pdf_link = responseData.pdf_link;
          detail.order_fabric_excel_link = responseData.order_fabric_excel_link
          detail.remaining_amount = responseData.remaining_amount

          self.modelProxy[index] = detail;
          self.sweetAlertSuccess(self.$t(self.is_editing ? 'general.successfully_updated' : 'general.successfully_created'));
        } else {
          let result = response.data.response;
          if (result.hasOwnProperty('data') && result.data.hasOwnProperty('message')) {
            self.sweetAlertError(result.data.message);
          } else {
            self.sweetAlertError(result.data);
          }
        }
        self.sweetAlertClose();
        self.is_submitting = false;
      });
    }
  },
  mounted() {
    if (this.yarnModel && this.yarnModel.length > 0) {
      this.modelProxy.forEach(model => {
        model.fabric_supply_type_id = this.fabricProcessingType;
        model.tolerance_amount = this.tolerances ? this.tolerances.knit_coefficient : 1;
        if (!+model.supplier_company_id) {
          model.supplier_company_id = this.yarnModel[0].supplier_company_id;
        }
      })
    }
    if(this.$route.query.qr_type=="knit-request"){
        setTimeout(() => {
            let instructionsId = this.$route.query.data.id
            let element = this.$refs["knit_request_"+instructionsId][0]
            if(element){
              element.scrollIntoView({behavior: "smooth"})
            }
          }, 2000);
      }
  },
  computed: {
    moment: () => moment,
    totalAmount() {
      return function (index) {
        this.modelProxy[index].total_amount = this.modelProxy[index].amount * (1 + (+this.modelProxy[index].tolerance_amount / 100))
        return (+this.modelProxy[index].total_amount);
      }
    },
    getOrderFabricOptions() {
      let items = this.orderFabricOptions;
      return this.convertArrayToObjectByKey(items, 'id', 'type');
    },
    modelProxy: {
      get() {
        return this.model;
      },
      set(value) {
        this.$emit('update:model', value);
      }
    },
    isValidToSubmit() {
      try {
        let returnData = null;

        returnData = function (key) {
          const current = this.modelProxy[key];
          if (+current.supplier_company_id === 0) return false;
          if (+current.fabric_knit_type_id === 0) return false;
          if (+current.weight === 0) return false;
          if (!current.fabric_type) return false;
          if (!current.order_size_and_color_id) return false;
          if (current.dispatch_location_ids.length === 0) return false;
          if (current.fein_pus === '' || current.fein_pus === null) return false;
          if (current.color === '' || current.color === null) return false;
          if (+current.amount === 0) return false;
          // if (current.selectedProductProcesses.length === 0) return false;
          if (+current.currency_unit_id === 0) return false;
          if (+current.expiry_id === 0) return false;
          if (+current.unit_price === 0) return false;
          if (+current.vat_rate_id === 0) return false;
          if (current.description === null || current.description === '') return false;
          return true;
        }
        return returnData;
      } catch (e) {
        console.error(e);
        return false;
      }
    },
    sendMailUrl() {
      try {
        let returnData = null;
        returnData = function (key) {
          const itemId = this.modelProxy[key].id;
          return `api/order/${this.orderId}/knit-request/${itemId}/share`
        }
        return returnData;
      } catch (e) {
        console.error(e);
        return false;
      }
    }
  },
  watch: {
    modelProxy: {
      handler(newValue, oldValue) {
        if (newValue) {
          let totalAmount = _.sumBy(this.modelProxy, 'amount');
          newValue.forEach(model => {
            model.fabric_supply_type_id = this.fabricProcessingType;
            model.tolerance_amount = this.tolerances.knit_coefficient;
            model.order_fabric_id = this.orderFabricId;
            if (!model.amount) {
              let amount = Number(_.sumBy(this.yarnModel, 'amount'));
              if (+model.fabric_supply_type_id === 1) {
                let tolerance = this.tolerances ? this.tolerances.paint_coefficient : 12;
                amount = amount + amount * tolerance / 100;
              } else if (+model.fabric_supply_type_id === 2) {
                amount = amount + amount * this.pressTypeTolerances[this.pressTypeId] / 100;
              }
              model.amount = amount.toFixed(2) - totalAmount;
            }
          })
        }
      },
      deep: true
    },
    orderFabricId(value) {
      this.modelProxy.forEach(model => {
        if (!model.amount) {
          let amount = Number(_.sumBy(this.yarnModel, 'amount'));
          if (+model.fabric_supply_type_id === 1) {
            let tolerance = this.tolerances ? this.tolerances.paint_coefficient : 12;
            amount = amount + amount * tolerance / 100;
          } else if (+model.fabric_supply_type_id === 2) {
            amount = amount + amount * this.pressTypeTolerances[this.pressTypeId] / 100;
          }
          model.amount = amount.toFixed(2);
        }
      })
    },
    orderSizeAndColorId(value) {
      this.modelProxy.forEach(model => {
        if (!model.amount) {
          let amount = Number(_.sumBy(this.yarnModel, 'amount'));
          if (+model.fabric_supply_type_id === 1) {
            let tolerance = this.tolerances ? this.tolerances.paint_coefficient : 12;
            amount = amount + amount * tolerance / 100;
          } else if (+model.fabric_supply_type_id === 2) {
            amount = amount + amount * this.pressTypeTolerances[this.pressTypeId] / 100;
          }
          model.amount = amount.toFixed(2);
        }
      })
    },
    tolerances(value) {
      if (value) {
        this.modelProxy.forEach(model => {
          model.tolerance_amount = this.tolerances ? this.tolerances.knit_coefficient : 5;
        })
      }
    }
  }
}
</script>
<style lang="scss">
/*Mobile Start*/
@import "@/assets/sass/mobile/order/orderFabricKnitTypeTable.scss";
/*Mobile End*/
</style>